import useSWR from "swr";
import fetcher from "../utils/fetch";
import { RelativeUrl } from "../utils/environment";

type MetaCTAType = string;

const useMetaCTATypes = () => {
  const { data, error, isLoading } = useSWR<MetaCTAType[]>(`${RelativeUrl}/meta/call_to_action_types`, fetcher, {
    revalidateIfStale: false // never refetch as settings will rarely change
  });

  return {
    ctaTypes: data || [],
    isLoading,
    error: error ? "Failed to fetch Meta CTA types" : null
  };
};

export default useMetaCTATypes;
